import type { RouteBundle } from '../../routes/contract';

/**
 * A screen module the data area's glob discovers on purpose, and which
 * contributes nothing: it keeps the discovery test from comparing two empty
 * lists while no real screen exists, so a glob that matches nothing fails.
 */
export const bundle: RouteBundle = { routes: [], nav: [] };
